var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-to-wishlist",class:_vm.isSavedInWishlist ? 'saved' : 'not-saved',on:{"click":_vm.toggle}},[_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }